import { useState } from "react";
import { api, handleErr } from "./api";
import { useAuth } from "../context/AuthContext";

export function useGenerate(task) {
  const { refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const run = async (prompt, options = {}, override) => {
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/generate", { task: override || task, prompt, options });
      setResult(data.result);
      return data.result;
    } catch (e) {
      setError(handleErr(e));
    } finally {
      setBusy(false);
      refresh();
    }
  };
  return { busy, result, setResult, error, run };
}
